export default "__VITE_ASSET__DZjLstDU__"